import React from 'react';
import { Main, Wrapper } from './LoadingScreen.styles';
import { Loading } from '../../../../CommonComponents/OPL/Loading/Loading';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { cardAnimationVariants, logoAnimationVariants } from '../../../BeFi20.meta';
import { Header } from '../StartPage/StartPage.styles';
import { BeFi20Logo } from '../../../img/BeFi20Logo';
import { ClientFooter } from '../../../../ConsumerArea/components/Footer/FooterView';

interface Props {
  text?: string;
  shouldAnimate?: boolean;
  isClientArea?: boolean;
}

export const LoadingScreen = ({ text, shouldAnimate = true, isClientArea = false }: Props) => {
  return (
    <>
      <Wrapper>
        <Header
          variants={shouldAnimate ? logoAnimationVariants : undefined}
          initial="enter"
          animate="visible"
        >
          <BeFi20Logo />
        </Header>

        <Main
          variants={shouldAnimate ? cardAnimationVariants : undefined}
          initial="enter"
          animate="visible"
        >
          <Box maxWidth={175}>
            <Loading text={text} size="medium" />
          </Box>
        </Main>
      </Wrapper>
      {isClientArea && <ClientFooter />}
    </>
  );
};
